import { render, staticRenderFns } from "./NewsCategoryUpdate.vue?vue&type=template&id=600d8617&"
import script from "./NewsCategoryUpdate.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports